"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.repayCnftPerpetualLoanCanopy = void 0;
const token_1 = require("@coral-xyz/anchor/dist/cjs/utils/token");
const common_1 = require("../../../../../common");
const constants_1 = require("../../../../constants");
const constants_2 = require("../../../../constants");
const offer_1 = require("../../offer");
const helpers_1 = require("./../../../../helpers");
const anchor_1 = require("@coral-xyz/anchor");
const repayCnftPerpetualLoanCanopy = (_a) => __awaiter(void 0, [_a], void 0, function* ({ programId, connection, args, accounts, sendTxn, }) {
    const program = (0, helpers_1.returnAnchorProgram)(connection);
    const instructions = [];
    const [mutualBondTradeTxnVault] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_2.MUTUAL_BOND_TRADE_TXN_VAULT)], program.programId);
    const [treeAuthority, _bump2] = anchor_1.web3.PublicKey.findProgramAddressSync([accounts.tree.toBuffer()], constants_1.BUBBLEGUM_PROGRAM_ID);
    const canopyDepth = yield (0, helpers_1.getTreeCanopyDepth)(accounts.tree, connection);
    const proofPathAsAccounts = (0, helpers_1.mapProof)(args.proof, canopyDepth);
    const root = (0, helpers_1.decode)(args.proof.root);
    const dataHash = (0, helpers_1.decode)(args.cnftParams.dataHash);
    const creatorHash = (0, helpers_1.decode)(args.cnftParams.creatorHash);
    const nonce = new anchor_1.BN(args.cnftParams.leafId);
    const index = args.cnftParams.leafId;
    const splTokenMint = (0, offer_1.getTokenMintFromLendingTokenType)(args.lendingTokenType);
    const [lenderVault, lenderVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
        constants_1.ENCODER.encode(constants_1.USER_VAULT_PREFIX),
        accounts.oldLender.toBuffer(),
        splTokenMint.toBuffer()
    ], program.programId);
    const userSplTokenAccountUninitialized = yield (0, common_1.findAssociatedTokenAddress)(accounts.userPubkey, splTokenMint);
    const vaultSplTokenAccountUninitialized = yield (0, common_1.findAssociatedTokenAddress)(lenderVault, splTokenMint);
    const protocolFeeReceiverSplTokenAccountUninitialized = yield (0, common_1.findAssociatedTokenAddress)(accounts.protocolFeeReceiver, splTokenMint);
    const remainingAccounts = [
        {
            pubkey: userSplTokenAccountUninitialized,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: vaultSplTokenAccountUninitialized,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: protocolFeeReceiverSplTokenAccountUninitialized,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: accounts.bondTradeTransaction,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: accounts.fbond,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: accounts.protocolFeeReceiver,
            isSigner: false,
            isWritable: true,
        },
    ];
    instructions.push(yield program.methods
        .repayCnftPerpetualLoan(root, dataHash, creatorHash, nonce, index, proofPathAsAccounts.length)
        .accountsStrict({
        user: accounts.userPubkey,
        mutualBondTradeTxnVault: mutualBondTradeTxnVault,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        merkleTree: accounts.tree,
        treeAuthority: treeAuthority,
        bubblegumProgram: constants_1.BUBBLEGUM_PROGRAM_ID,
        compressionProgram: constants_1.SPL_ACCOUNT_COMPRESSION_PROGRAM_ID,
        logWrapper: constants_1.SPL_NOOP_PROGRAM_ID,
        bondOffer: accounts.oldBondOffer,
        tokenProgram: token_1.TOKEN_PROGRAM_ID,
        splTokenMint,
        associatedTokenProgram: token_1.ASSOCIATED_PROGRAM_ID,
        lenderVault,
    })
        .remainingAccounts([...remainingAccounts, ...proofPathAsAccounts])
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [];
    yield sendTxn(transaction, signers);
    return {
        instructions,
        signers,
        accounts: {
            fraktBond: accounts.fbond,
            oldBondOffer: accounts.oldBondOffer,
            bondTradeTransaction: accounts.bondTradeTransaction,
            lenderVault,
        }
    };
});
exports.repayCnftPerpetualLoanCanopy = repayCnftPerpetualLoanCanopy;
